// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2pRKC","info":"PatientInfo_info__1HvRF"};